import React, { lazy, Suspense } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';
import { PUBLIC_ROUTE } from './route.constants';
import Loader from '@iso/components/utility/loader';

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    // component: RootRoutingComponent,
    component: lazy(() => import('@iso/containers/Pages/LocalEats/LocalEats')),
  },
  {
    path: PUBLIC_ROUTE.LANDING_URL,
    exact: true,
    // component: RootRoutingComponent,
    component: lazy(() => import('@iso/containers/Pages/LocalEats/LocalEats')),

  },
];


export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Switch>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))}
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
